import React from 'react';
import CodeIcon from '@material-ui/icons/Code';
import { useTranslation } from 'react-i18next';
import '../TracePanelStyles.css';

export const detectContextValueType = (value, name) => {
    if (value === null || value === undefined || String(value).trim() === '') {
        return 'empty';
    }

    const text = String(value).trim();
    const normalizedName = (name || '').toLowerCase();

    if (text === 'true' || text === 'false') {
        return 'boolean';
    }
    if (/^-?\d+(\.\d+)?$/.test(text)) {
        return 'number';
    }
    if (/^\d{4}-\d{2}-\d{2}(?:[T\s]|$)/.test(text)) {
        return 'date';
    }
    if (
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(text)
        || (normalizedName.includes('session') && text.length > 16)
    ) {
        return 'uuid';
    }
    if (/^https?:\/\//i.test(text)) {
        return 'url';
    }

    return 'string';
};

const ContextValue = ({ value, name }) => {
    const type = detectContextValueType(value, name);

    if (type === 'empty') {
        return <span className="context-variables-value context-variables-value--empty">—</span>;
    }

    const text = String(value);

    if (type === 'boolean') {
        const isTrue = text === 'true';
        return (
            <span className={`context-variables-value context-variables-value--boolean ${isTrue ? 'is-true' : 'is-false'}`}>
                {text}
            </span>
        );
    }

    return (
        <span className={`context-variables-value context-variables-value--${type}`}>
            {text}
        </span>
    );
};

const ContextVariablesPanel = ({ items }) => {
    const { t } = useTranslation();

    if (!items.length) {
        return null;
    }

    return (
        <div className="context-variables-panel">
            <div className="context-variables-header">
                <CodeIcon className="context-variables-header-icon" fontSize="small" />
                <span>{t('Context variables')}</span>
            </div>
            <div className="context-variables-list">
                {items.map((item) => (
                    <div
                        className="context-variables-row"
                        key={`${item.name}-${item.id ?? item.text}`}
                    >
                        <div className="context-variables-key">{item.name}</div>
                        <div className="context-variables-value-cell">
                            <ContextValue value={item.text} name={item.name} />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ContextVariablesPanel;
